import { render, staticRenderFns } from "./resuliList.vue?vue&type=template&id=9058d872&scoped=true&"
import script from "./resuliList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./resuliList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./resuliList.vue?vue&type=style&index=0&id=9058d872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9058d872",
  null
  
)

export default component.exports